import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { TranslatePipe } from '../../filters/translate.pipe';
import { CardServiceComponent } from '../../components/card-service/card-service.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { PanelDirective } from '../../directives/panel.directive';
import ServiceRestServices from '../../services/service-rest.service';
import Config from '../../utils/config.service';
import FetchingService from '../../services/fetching.service';
import Session from '../../utils/session.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'partners',
	templateUrl: './partners.component.html',
	imports: [ CommonModule, FormsModule, MatSelectModule, PanelDirective, TranslatePipe, CardServiceComponent, LoaderOverlayComponent, ItemNoContentComponent ]
})
export default class PartnersComponent implements OnInit, OnDestroy {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private config: Config = inject(Config);
	private fetchingService: FetchingService = inject(FetchingService);
	private session: Session = inject(Session);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	private searchSubject: Subject<string> = new Subject<string>();
	private searchSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
		this.vm.search = {};
	}
	
	ngOnInit() {
		this.routingService.validateAccess('partners').then(() => {
			this.vm.user = this.session.getSession().user;
			this.vm.searchLanguages = this.config.getServiceLanguages();
			this.vm.typeOfAppointments = ['FACE_TO_FACE_SESSION_ONLY', 'VIDEO_SESSION_ONLY'];
			this.vm.services = [];
			this.vm.pageSize = 24;
			this.vm.getLanguagesText = this.getLanguagesText;
			this.vm.triggerSearch = this.triggerSearch;
			this.vm.searchPartners = this.searchPartners;
			this.getTherapiesTranslations();
			this.searchPartners(true);
		});
		
		this.searchSubscription = this.searchSubject.pipe(
			debounceTime(500)
		).subscribe(() => {
			this.triggerSearch();
		});
	}
	
	ngOnDestroy() {
		if (this.searchSubscription) {
			this.searchSubscription.unsubscribe();
		}
	}
	
	onSearchChange(searchTerm: string) {
		this.searchSubject.next(searchTerm);
	}
	
	triggerSearch() {
		this.searchPartners(true);
	}
	
	searchPartners(isInitial) {
		if (this.vm.loading) return;
		this.vm.loading = true;
		this.vm.isInitial = isInitial;
		var params: any = {
			start: isInitial ? 0 : this.vm.services.length,
			pageSize: this.vm.pageSize
		};
		if (this.vm.search.term && this.vm.search.term.trim()) {
			params.name = this.vm.search.term.trim();
		}
		if (this.vm.search.lang) {
			params.languages = Array.isArray(this.vm.search.lang)
				? this.vm.search.lang.join(',')
				: this.vm.search.lang;
		}
		if (this.vm.search.typeOfAppointment) {
			params.typeOfAppointment = this.vm.search.typeOfAppointment;
		}
		
		this.serviceRestServices.getPartnerServices(params, (services) => {
			services = services || [];
			this.vm.services = isInitial ? services : this.vm.services.concat(services);
			this.vm.isLast = services.length < this.vm.pageSize;
			this.vm.loading = false;
			this.vm.initialized = true;
		}, () => {
			this.vm.services = [];
			this.vm.isLast = true;
			this.vm.loading = false;
			this.vm.initialized = true;
		});
	}
	
	getLanguagesText() {
		if (!this.vm.search.lang || !this.vm.search.lang.length) {
			return '';
		}
		return this.vm.search.lang
			.map(lang => this.vm.searchLanguages.indexOf(lang) >= 0 ? lang : null)
			.filter(lang => !!lang)
			.join(', ');
	}
	
	getTherapiesTranslations() {
		this.fetchingService.get('THERAPY_TOPIC_TRANSLATIONS', { params: { language: this.vm.user?.deviceLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.therapyTranslations = response;
			});
	}
}
